import usePrivateAxios from "@/common/api/usePrivateAxios"
import { EstablishmentUserData } from "@/common/types/establishmentUsers.type";
import { getRailsUpdate } from "@/common/utils/getRailsUpdate";
import { mapToDeletion } from "@/common/utils/railsHelpers";
import { transformNewRoles } from "@/common/utils/roleTransformers";
import { removeSpecialCharacters } from "@/common/utils/unFormatters"
import { EstablishmentUserValidationSchema } from "@/features/establishments/schemas/create.schema"
import { useMutation } from "@tanstack/react-query"
import { AxiosError } from "axios";

interface UseUpdateEstablishmentUser {
  establishmentUser: EstablishmentUserData | undefined,
  contactId?: string,
  establishmentId?: string,
  file: Blob | undefined,
  onSuccess: () => void,
  onError: (error: AxiosError) => void;
}

export const useUpdateEstablishmentUser = ({ establishmentUser, contactId, establishmentId, file, onSuccess, onError }: UseUpdateEstablishmentUser) => {
  const privateAxios = usePrivateAxios()
  return useMutation({
    mutationKey: ['updatedEstablishmentUser'],
    mutationFn: async (form: EstablishmentUserValidationSchema) => {
      const payload = {
        establishment_id: establishmentId,
        cpf: removeSpecialCharacters(form.cpf),
        date_of_birth: form.date_of_birth || null,
        full_name: form.full_name,
        status: form?.status?.value || 'enabled',
        phone_attributes: { number: form?.phone?.number ? removeSpecialCharacters(form?.phone?.number) : null },
        email: form.email || null,
        user_roles_attributes: getRailsUpdate(
          establishmentUser?.user_roles || [],
          form?.roles || [],
          (userRole) => userRole.role.id,
          (role) => role.value || '',
          mapToDeletion,
          transformNewRoles,
        ),
        profile_picture: file ? file : undefined
      }

      return privateAxios.putForm(`/establishment/users/${contactId}`, { establishment_user: payload })
    },
    onSuccess,
    onError,
  })
}
